// @mui material components
import Card from "@mui/material/Card";

// Kaizen Dashboard components
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Images
import curved6 from "assets/images/background_signin.jpg";
import errorIcon from "assets/images/error.svg";

function ErrorHandler() {
  return (
    <BasicLayout
      title="Ha ocurrido un error"
      description="Nuestro equipo de soporte está trabajando para solucionarlo"
      image={curved6}
    >
      <Card>
        <SoftBox p={3} mb={1} textAlign="center">
          <img style={{ height: "200px" }} src={errorIcon}></img>
        </SoftBox>
        <SoftBox pt={2} pb={3} px={3}>
          <SoftBox component="form" role="form">
            <SoftBox px={3} mb={1} textAlign="center">
              <SoftTypography variant="h5" fontWeight="medium">
                Ha ocurrido un error
              </SoftTypography>
            </SoftBox>
            <SoftBox mt={2} mb={1}>
              <SoftButton
                color="gobSecondary"
                fullWidth
                onClick={() => {
                  localStorage.removeItem("error");
                  window.location.href = "/";
                }}
              >
                Volver a inicio
              </SoftButton>
            </SoftBox>
          </SoftBox>
        </SoftBox>
      </Card>
    </BasicLayout>
  );
}

export default ErrorHandler;
